import { useTranslation } from 'react-i18next';
import { HiExclamationCircle, HiRefresh } from 'react-icons/hi';
import { mensajeDeError } from '../utils/apiError';

/**
 * «No se pudo cargar», dicho de una vez y en un solo sitio.
 *
 * Va donde antes iba el estado vacío cuando la carga falla, para que «no tienes
 * nada» y «no he podido leerlo» dejen de verse igual. Lleva el motivo que
 * devolvió el servidor y un botón para reintentar, porque la mayoría de estos
 * fallos son pasajeros.
 */
export default function ErrorAlCargar({ error, onReintentar, className = '' }) {
    const { t } = useTranslation();

    return (
        <div className={`card !border-l-4 !border-l-red-500 ${className}`}>
            <div className="flex items-start gap-3">
                <HiExclamationCircle className="w-6 h-6 text-red-500 flex-shrink-0 mt-0.5" />
                <div className="min-w-0 flex-1">
                    <h3 className="font-semibold text-slate-900 dark:text-white">
                        {t('common.load_failed_title')}
                    </h3>
                    <p className="text-sm text-slate-500 mt-1">
                        {mensajeDeError(error, t('common.load_failed_desc'))}
                    </p>
                    {onReintentar && (
                        <button type="button" onClick={onReintentar} className="btn-secondary btn-sm mt-3">
                            <HiRefresh className="w-4 h-4 mr-1" />
                            {t('common.retry')}
                        </button>
                    )}
                </div>
            </div>
        </div>
    );
}
